import { render, staticRenderFns } from "./ListEquipamento.vue?vue&type=template&id=b83d0676&scoped=true&"
import script from "./ListEquipamento.vue?vue&type=script&lang=js&"
export * from "./ListEquipamento.vue?vue&type=script&lang=js&"
import style0 from "./ListEquipamento.vue?vue&type=style&index=0&id=b83d0676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83d0676",
  null
  
)

export default component.exports